export const JOB_INVITE_INVITES_RECEIVED_SEE_REQUEST = 'job-invite/invites-received-see-request'
export const JOB_INVITE_INVITES_RECEIVED_SEE_SUCCESS = 'job-invite/invites-received-see-success'
export const JOB_INVITE_INVITES_RECEIVED_SEE_FAILED = 'job-invite/invites-received-see-failed'
